export const BUILD_TIME_RENEWAL_ENABLED = true;

export const isRenewalEnabledSeller = (debugPanelRenewalEnabledSeller: boolean): boolean =>
  BUILD_TIME_RENEWAL_ENABLED || debugPanelRenewalEnabledSeller;
